import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { fields: fieldsCopy } = copy.filter;

export const getFields = (): IFormFields => {
  return [
    {
      name: "query",
      type: IFieldType.search,
      label: fieldsCopy.title,
      style: { gridColumn: "1/2" },
    },
    {
      name: "country",
      type: IFieldType.country,
      label: fieldsCopy.country,
      style: { gridColumn: "2/3" },
    },
  ] as IFormFields;
};
